import { Box, Grid, Typography } from "@mui/material";
import HeroImage from "./../assets/Products - Background.png";


const HeroSection = () => {
    return (
        <Box sx={{
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'flex-end',
            height: 'calc(100vh - 70px)',
            overflow: 'hidden',
            backgroundImage: `
                linear-gradient(
                    to bottom, 
                    #EBEEF3 0%, 
                    #EBEEF300 40%
                ),
                radial-gradient(
                    circle at 0% 70%, 
                    #EBEEF300 0%,
                    #EBEEF303 35%,
                    #EBEEF3 55%,
                    #EBEEF3 100%
                ),
                linear-gradient(
                    to top, 
                    #EBEEF3 0%, 
                    #EBEEF300 40%
                );`,

            '@media (max-width: 1000px)': {
                backgroundImage: `
                    radial-gradient(
                        circle at 30% 80%, 
                        #EBEEF300 0%,
                        #EBEEF303 25%,
                        #EBEEF3 45%,
                        #EBEEF3 100%
                    ),
                    linear-gradient(
                        to top, 
                        #EBEEF3 0%, 
                        #EBEEF300 40%
                    );`,
            },
        }}>
            {/* Background Images */}
            <Box sx={{
                position: 'absolute',
                top: '0px',
                left: '0',
                width: '100%',
                height: 'calc(100vh - 75px)',
                zIndex: '-1',
                textAlign: 'left',
            }}>
                <img src={ HeroImage } alt="" style={{ 
                    zIndex: '-2',
                    boxShadow: 'inset (-10) 0 3 (-12);',
                    height: '100%', 
                    objectFit: 'fill' 
                }} />
            </Box>

            {/* Main Content */}
            <Box textAlign="right" sx={{
                marginTop: '10vh',
                paddingBottom: '10vh',
                marginLeft: '60px',
                marginRight: '60px',

                '@media (max-width: 750px)': {
                    marginTop: '10vh',
                },

                '@media (min-width: 2000px)': {
                    marginRight: 'calc(50% - 1000px)',
                },
            }}>
                <Box sx={{ 
                    textAlign: 'right',
                }}>
                    <Typography sx={{ 
                        fontFamily: 'Red Rose', 
                        textTransform: 'none', 
                        fontWeight: '400', 
                        fontSize: '64px', 
                        lineHeight: '80%',
                        color: '#3B0E59',

                        '@media (max-width: 600px)': {
                            fontSize: '48px',
                        },
                        '@media (max-width: 400px)': {
                            fontSize: '36px',
                        }
                    }}>
                        <span style={{ color: '#6841f2' }}>All-in-One</span> Platform
                    </Typography>
                </Box>

                {/* Use Subheading */}
                <Box sx={{ textAlign: 'right' }}>
                    <Typography sx={{ 
                        fontFamily: 'Raleway', 
                        textTransform: 'none', 
                        fontSize: '20px', 
                        color: '#212529',

                        marginTop: '30px',

                        '@media (max-width: 600px)': {
                            fontSize: '16px',
                            marginTop: '20px',
                        },
                    }}>
                        All the tools you need to manage your business. In one place.
                    </Typography>
                </Box>
                <Box sx={{ textAlign: 'right' }}>
                    <Typography sx={{ 
                        fontFamily: 'Raleway', 
                        textTransform: 'none', 
                        fontSize: '20px', 
                        color: '#212529',

                        '@media (max-width: 600px)': {
                            fontSize: '16px',
                            marginTop: '20px',
                        },
                    }}>
                        See how we can help you grow your business.
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};



export default () => (
    <>
        <HeroSection />

        <Box sx={{
            width: '100%',
            maxWidth: '900px',
            marginLeft: 'auto',
            marginRight: 'auto',
        }}>
            <Box sx={{
                paddingLeft: '35px',
                paddingRight: '35px',
            }}>
                <></>
            </Box>
        </Box>
    </>
);